import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Almacen from "views/admin/almacen";
import Categories from "views/admin/categorias";
import Marcas from "views/admin/marcas";
import Medidas from "views/admin/medidas";
import Proveedores from "views/admin/proveedores";
import Compras from "views/admin/compras";
import Productos from "views/admin/productos";
import Ventas from "views/admin/ventas";
import Caja from "views/admin/caja";
import Operacion from "views/admin/operacion";
import Pos from "views/admin/pos";
import Servicios from "views/admin/servicios";
import Usuarios from "views/admin/usuarios";
import Clientes from "views/admin/clientes";
import Asistencias from "views/admin/asistencias";
import Kardex from "views/admin/kardex";
import NotFound from "views/admin/notfound";
import VentasByUser from "views/admin/ventasbyuser";
import Profile from "views/admin/profile";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdDoorFront,
  MdDashboard,
  MdKeyboardHide,
  MdPointOfSale,
  MdAdminPanelSettings,
  MdOutlineRequestQuote,
} from "react-icons/md";
import { IoAlbums, IoBagHandle, IoBarChart, IoCube, IoGrid } from "react-icons/io5";
import { FaBoxes, FaCubes, FaHive, FaHome, FaMoneyCheckAlt, FaShoppingBag, FaTools, FaVectorSquare, FaWarehouse, FaWeight } from "react-icons/fa";
import { FaBuilding, FaCashRegister, FaChartBar, FaFileSignature, FaReceipt, FaStore, FaTags } from "react-icons/fa6";
import Reabastecer from "views/admin/reabastecer";
import ReporteGeneral from "views/admin/reportegeneral";
import ReporteByProduct from "views/admin/reportebyproduct";
import ReporteByUser from "views/admin/reportebyuser";
import { AiOutlineBarChart } from "react-icons/ai";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { BsBuilding } from "react-icons/bs";
import { FiArchive, FiBriefcase } from "react-icons/fi";

const routes = [
  {
    sector: "dashboard",
    autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
    elementos: [{
      name: "Panel de Control",
      layout: "/admin",
      path: "default",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><MdDashboard className="h-5 w-5 text-white" /></div>,
      component: <MainDashboard />,
      autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
      desplegable: false,
      subelementos: []
    }]
  },
  {
    sector: "logistica",
    autoridad: ["ADMIN"],
    elementos: [{
      name: "Almacén",
      layout: "/admin",
      path: "almacen",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaWarehouse className="h-5 w-5 text-white" /></div>,
      component: <Almacen />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Categorias",
      layout: "/admin",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaHive className="h-5 w-5 text-white" /></div>,
      path: "categorias",
      component: <Categories />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Marcas",
      layout: "/admin",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaVectorSquare className="h-5 w-5 text-white" /></div>,
      path: "marcas",
      component: <Marcas />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Unidades de Medida",
      layout: "/admin",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaWeight className="h-5 w-5 text-white" /></div>,
      path: "umedidas",
      component: <Medidas />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Compras",
      layout: "/admin",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaShoppingBag className="h-5 w-5 text-white" /></div>,
      path: null,
      component: null,
      autoridad: ["ADMIN"],
      desplegable: true,
      subelementos: [
        {
          name: "Proveedores",
          layout: "/admin",
          icon: null,
          path: "proveedores",
          component: <Proveedores />,
          autoridad: ["ADMIN"],
          desplegable: false,
          subelementos: []
        },
        {
          name: "Reabastecer",
          layout: "/admin",
          icon: null,
          path: "reabastecer",
          component: <Reabastecer />,
          autoridad: ["ADMIN"],
          desplegable: false,
          subelementos: []
        },
        {
          name: "Compras",
          layout: "/admin",
          icon: null,
          path: "compras",
          component: <Compras />,
          autoridad: ["ADMIN"],
          desplegable: false,
          subelementos: []
        }
      ]
    },
    {
      name: "Artículos",
      layout: "/admin",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaCubes className="h-5 w-5 text-white" /></div>,
      path: null,
      component: null,
      autoridad: ["ADMIN"],
      desplegable: true,
      subelementos: [
        {
          name: "Productos",
          layout: "/admin",
          icon: null,
          path: "productos",
          component: <Productos />,
          autoridad: ["ADMIN"],
          desplegable: false,
          subelementos: []
        },
        {
          name: "Servicios",
          layout: "/admin",
          icon: null,
          path: "servicios",
          component: <Servicios />,
          autoridad: ["ADMIN"],
          desplegable: false,
          subelementos: []
        }
      ]
    }]
  },
  {
    sector: "Gestion de ventas",
    autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
    elementos: [{
      name: "POS - Punto de venta",
      layout: "/admin",
      path: "pos",
      icon: <div className="h-8 w-8 rounded-xl bg-green-500 dark:bg-green-400 flex items-center justify-center"><MdPointOfSale className="h-5 w-5 text-white" /></div>,
      component: <Pos />,
      autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Ventas generales",
      layout: "/admin",
      path: "ventas",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaStore className="h-5 w-5 text-white" /></div>,
      component: <Ventas />,
      autoridad: ["ADMIN", "CAJERO"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Mis ventas",
      layout: "/admin",
      path: "ventasbyuser",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaReceipt className="h-5 w-5 text-white" /></div>,
      component: <VentasByUser />,
      autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
      desplegable: false,
      subelementos: []
    }, {
      name: "Caja",
      layout: "/admin",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaCashRegister className="h-5 w-5 text-white" /></div>,
      path: null,
      component: null,
      autoridad: ["ADMIN", "CAJERO"],
      desplegable: true,
      subelementos: [
        {
          name: "Caja chica",
          layout: "/admin",
          icon: null,
          path: "caja",
          component: <Caja />,
          autoridad: ["ADMIN", "CAJERO"],
          desplegable: false,
          subelementos: []
        },
        {
          name: "Gastos/Ingresos",
          layout: "/admin",
          icon: null,
          path: "operacion",
          component: <Operacion />,
          autoridad: ["ADMIN", "CAJERO"],
          desplegable: false,
          subelementos: []
        }
      ]
    }]
  },
  {
    sector: "Contabilidad",
    autoridad: ["ADMIN"],
    elementos: [{
      name: "Kardex productos",
      layout: "/admin",
      path: "kardex",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaBoxes className="h-5 w-5 text-white" /></div>,
      component: <Kardex />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    },
    {
      name: "Reporte de ventas",
      layout: "/admin",
      path: null,
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaChartBar className="h-5 w-5 text-white" /></div>,
      component: null,
      autoridad: ["ADMIN"],
      desplegable: true,
      subelementos: [
        {
          name: "Reporte general",
          layout: "/admin",
          icon: null,
          path: "reportegeneral",
          component: <ReporteGeneral />,
          autoridad: ["ADMIN", "CAJERO"],
          desplegable: false,
          subelementos: []
        },
        {
          name: "Reporte por producto",
          layout: "/admin",
          icon: null,
          path: "reportebyproduct",
          component: <ReporteByProduct />,
          autoridad: ["ADMIN", "CAJERO"],
          desplegable: false,
          subelementos: []
        },
        {
          name: "Reporte por usuario",
          layout: "/admin",
          icon: null,
          path: "reportebyuser",
          component: <ReporteByUser />,
          autoridad: ["ADMIN", "CAJERO"],
          desplegable: false,
          subelementos: []
        }
      ]
    }]
  },
  {
    sector: "Gestion RRHH",
    autoridad: ["ADMIN"],
    elementos: [
      {
        name: "Administración",
        layout: "/admin",
        path: null,
        icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaTools className="h-5 w-5 text-white" /></div>,
        component: null,
        autoridad: ["ADMIN"],
        desplegable: true,
        subelementos: [
          {
            name: "Usuarios",
            layout: "/admin",
            icon: null,
            path: "usuarios",
            component: <Usuarios />,
            autoridad: ["ADMIN"],
            desplegable: false,
            subelementos: []
          },
          {
            name: "Pagos",
            layout: "/admin",
            icon: null,
            path: "pagos",
            component: <NotFound />,
            autoridad: ["ADMIN"],
            desplegable: false,
            subelementos: []
          },
          {
            name: "Asistencias",
            layout: "/admin",
            icon: null,
            path: "asistencias",
            component: <Asistencias />,
            autoridad: ["ADMIN"],
            desplegable: false,
            subelementos: []
          },
          {
            name: "Clientes",
            layout: "/admin",
            icon: null,
            path: "clientes",
            component: <Clientes />,
            autoridad: ["ADMIN"],
            desplegable: false,
            subelementos: []
          }
        ]
      }]
  },
  {
    sector: "Confiuración del sistema",
    autoridad: ["ADMIN"],
    elementos: [
      {
        name: "Sunat",
        layout: "/admin",
        path: null,
        icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaFileSignature className="h-5 w-5 text-white" /></div>,
        component: null,
        autoridad: ["ADMIN"],
        desplegable: true,
        subelementos: [
          {
            name: "Tipos de tributo",
            layout: "/admin",
            icon: null,
            path: "tributo",
            component: <NotFound />,
            autoridad: ["ADMIN", "CAJERO"],
            desplegable: false,
            subelementos: []
          },
          {
            name: "Correlativos",
            layout: "/admin",
            icon: null,
            path: "correlativonumeracion",
            component: <NotFound />,
            autoridad: ["ADMIN", "CAJERO"],
            desplegable: false,
            subelementos: []
          }
        ]
      },
      {
        name: "Empresa",
        layout: "/admin",
        path: null,
        icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaBuilding className="h-5 w-5 text-white" /></div>,
        component: null,
        autoridad: ["ADMIN"],
        desplegable: true,
        subelementos: [
          {
            name: "Configuración general",
            layout: "/admin",
            icon: null,
            path: "confgeneral",
            component: <NotFound />,
            autoridad: ["ADMIN", "CAJERO"],
            desplegable: false,
            subelementos: []
          },
          {
            name: "Notificaciones",
            layout: "/admin",
            icon: null,
            path: "notificaciones",
            component: <NotFound />,
            autoridad: ["ADMIN", "CAJERO"],
            desplegable: false,
            subelementos: []
          }
        ]
      }]
  },
  {
    sector: "otros",
    autoridad: ["ADMIN"],
    elementos: [{
      name: "Otros",
      layout: "/admin",
      path: "otros",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><FaTags className="h-5 w-5 text-white" /></div>,
      component: <NotFound />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }]
  },
  {
    sector: "profile",
    autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
    hide: true,
    elementos: [{
      name: "Profile",
      layout: "/admin",
      path: "profile",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><MdDashboard className="h-5 w-5 text-white" /></div>,
      component: <NotFound />,
      autoridad: ["ADMIN", "CAJERO", "VENDEDOR"],
      desplegable: false,
      subelementos: []
    }]
  },
  {
    sector: "auth",
    autoridad: ["ADMIN"],
    hide: true,
    elementos: [{
      name: "Sign In",
      layout: "/auth",
      path: "/sign-in",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><MdLock className="h-5 w-5 text-white" /></div>,
      component: <SignIn />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }]
  },
  {
    sector: "auth",
    autoridad: ["ADMIN"],
    hide: true,
    elementos: [{
      name: "Sign up",
      layout: "/auth",
      path: "/sign-up",
      icon: <div className="h-8 w-8 rounded-xl bg-brand-500 dark:bg-brand-400 flex items-center justify-center"><MdLock className="h-5 w-5 text-white" /></div>,
      component: <SignIn />,
      autoridad: ["ADMIN"],
      desplegable: false,
      subelementos: []
    }]
  },
];

export default routes;
